import React from "react";

const RotateIcon = () => {
  return (
    <svg
      id="control-rotate"
      className="control__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.4 13.2"
    >
      <path
        d="m3.6697 10.215-3.6697-4.463h2.182s0.09919-1.9836 1.7852-3.7688c0 0 1.7852-1.9836 4.6613-1.9836 2.8761 0 4.2647 1.091 5.5542 2.777 1.2894 1.6861 1.1902 3.5705 1.1902 3.5705s0.09919 3.2729-2.182 5.0583c-2.2811 1.7852-4.463 1.6861-4.463 1.6861v-2.4795s1.6861 0.09919 2.9754-1.2894c1.1902-1.1902 1.091-2.9754 1.091-2.9754s0.09919-1.8844-1.6861-3.1738c-1.7852-1.2894-4.2647-0.79346-5.4549 0.69427-0.8926 0.99179-0.8926 1.9836-0.8926 1.9836h2.4795z"
        fill="#fff"
        strokeWidth=".26458"
      />
    </svg>
  );
};

export default RotateIcon;
